import React from "react";
/*
  Renders a menu header
    props:
    state:
*/

var Tooltip = require("../ui_elements/tooltip").Tooltip;
var TooltipMixin = require("../ui_elements/tooltip").TooltipMixin;
var Isvg = require("../../../vendor/react-inlinesvg");

class MenuHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    // Apply TooltipMixin
    this.showTooltip = TooltipMixin.showTooltip.bind(this);
    this.removeTooltip = TooltipMixin.removeTooltip.bind(this);
    this._addTooltipEvent = TooltipMixin._addTooltipEvent.bind(this);
    this._removeTooltipEvent = TooltipMixin._removeTooltipEvent.bind(this);
    this._addTooltip = this._addTooltip.bind(this);
    this._removeTooltip = this._removeTooltip.bind(this);
    this._addZoomTooltipEvent = this._addZoomTooltipEvent.bind(this);
  }

  // Add the tooltip
  _addTooltip(e) {
    this.showTooltip(
      $(e.currentTarget),
      $(e.currentTarget).data("tooltip"),
      $(e.currentTarget).data("tooltip-location")
    );
  }

  // Remove the tooltip
  _removeTooltip() {
    this.removeTooltip();
  }

  _addZoomTooltipEvent(e) {
    var button = $(e.currentTarget);
    if (!button.is(":disabled")) {
      this._addTooltipEvent(e);
    }
  }

  render() {
    var tooltip = this.props["menu-tooltip"];

    return (
      <div className="menu-header-container">
        <h3 tabIndex={-1} className="menu-header" id="menu-header">
          {this.props.children}
        </h3>
        {tooltip && (
          <button
            className="noButton info-button"
            data-tooltip={tooltip}
            data-target-dom-id="menu-header"
            data-tooltip-left="0"
            data-tooltip-top="-35"
            onFocus={this._addZoomTooltipEvent}
            onBlur={this._removeTooltipEvent}
            onMouseEnter={this._addZoomTooltipEvent}
            onMouseLeave={this._removeTooltipEvent}
          >
            <Isvg src="/img/info.svg" />
            <span className="offScreen">{tooltip}</span>
          </button>
        )}
        <Tooltip tooltip={this.state.tooltip} />
      </div>
    );
  }
}

module.exports = MenuHeader;
